import React from 'react';
import { Text } from 'theme-ui';
import WhatsNewContentBlock from '../../components/WhatsNewContentBlock/WhatsNewContentBlock';
import { LightRawHtml } from '../../shared-styled/typography/HTML';
import BasePageWrap from '../BasePage';
import {
  Author,
  ContentContainer,
  WhatsNewContainer,
  WhatsNewTitle,
  WhatsNewWrapper,
} from './WhatsNewPage.styled';

const WhatsNewPage = ({
  title,
  titleOne,
  descriptionOne,
  imageOne,
  pageUrlOne,
  titleTwo,
  descriptionTwo,
  imageTwo,
  pageUrlTwo,
  titleThree,
  descriptionThree,
  imageThree,
  pageUrlThree,
  otherDetails,
  author,
}) => (
  <WhatsNewWrapper>
    <WhatsNewContainer>
      <WhatsNewTitle>{title}</WhatsNewTitle>
      <ContentContainer>
        <WhatsNewContentBlock
          title={titleOne}
          description={descriptionOne}
          img={imageOne}
          url={pageUrlOne}
        />
        <WhatsNewContentBlock
          title={titleTwo}
          description={descriptionTwo}
          img={imageTwo}
          url={pageUrlTwo}
        />
        <WhatsNewContentBlock
          title={titleThree}
          description={descriptionThree}
          img={imageThree}
          url={pageUrlThree}
        />
      </ContentContainer>
      <LightRawHtml html={otherDetails} />
    </WhatsNewContainer>
  </WhatsNewWrapper>
);

export default BasePageWrap(WhatsNewPage);
